export default __webpack_public_path__ + "static/media/Mia_9781408303481.7325588c.jpg";